/* import __COLOCATED_TEMPLATE__ from './inbox-seat-column-tooltip-with-opener.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();